import { render, staticRenderFns } from "./ShowPerformance.vue?vue&type=template&id=0a2630e8&scoped=true"
import script from "./ShowPerformance.vue?vue&type=script&lang=js"
export * from "./ShowPerformance.vue?vue&type=script&lang=js"
import style0 from "./ShowPerformance.vue?vue&type=style&index=0&id=0a2630e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2630e8",
  null
  
)

export default component.exports